import React, { useContext } from "react";
import { loadStripe } from "@stripe/stripe-js";
import { CheckoutElementsProvider } from "@stripe/react-stripe-js/checkout";
import { Language } from "../../../App";

const publishableKey = import.meta.env.REACT_APP_STRIPE_PUBLISHABLE_KEY;

let stripePromise = null;

if (publishableKey && !publishableKey.includes("replace_me")) {
  stripePromise = loadStripe(publishableKey);
}

export function CheckoutProvider({ clientSecret, children }) {
  const { lang } = useContext(Language) || {};
  if (!stripePromise) {
    return (
      <div className="rounded-md bg-warning p-4 text-sm mt-3">
        <strong>{lang?.stripe_key_missing || "Stripe publishable key missing."}</strong>
        <p className="mt-1">
          {lang?.stripe_key_missing_instruction || "Add REACT_APP_STRIPE_PUBLISHABLE_KEY to load Stripe Elements."}
        </p>
      </div>
    );
  }

  if (!clientSecret) {
    return null;
  }

  return (
    <CheckoutElementsProvider
      stripe={stripePromise}
      options={{
        clientSecret,
        elementsOptions: { appearance: { theme: "stripe" } },
      }}
    >
      {children}
    </CheckoutElementsProvider>
  );
}
